import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as Func from "../../../../../helpers/functions";
import Modal from '../../../common/component/Modal';
import Button from '../../../common/component/Button';
import Span from '../../../common/component/Span';
import Dropdown from '../../../common/component/Dropdown';
import { PATHS } from '../../../../../constants/Define';

export const EditComponent = (props) => {

    const { t } = useTranslation();
    const removeGroup = () => {
        props.onDeleteGroup({ id: props.item.id })
    }
    const cloneGroup = () => {
        props.onCloneGroup({ id: props.item.id })
    }
    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.group.title`)),
            content: props.item.name,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeGroup,
        });
    };
    const onClone = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.15'), t(`item.group.title`)),
            content: props.item.name,
            okText: t(`action.clone`),
            cancelText: t(`action.cancel`),
            onOk: cloneGroup,
        });
    };
    const deleteDisabled = !(((new Date(props.item.saleStartDate)).getTime() > (new Date()).getTime()));
    const updateAllowed = !((new Date(props.item.endDate)).getTime() < (new Date()).getTime())
    return (
        <Span>
            {/* {
                props.permissionActions && props.permissionActions.allowUpdate && (
                    <Link to={`/groups/action/${props.item.id}`} className={`mr-2 colorPrimary`}>
                        <CPN.Icon type={updateAllowed ? "form" : "eye"} className="fs20" />
                    </Link>
                )
            }
            {
                // !(((new Date(props.item.saleStartDate)).getTime() > (new Date()).getTime())) && (
                //     <Link to={`/groups/action/${props.item.id}`} className={`mr-2 colorPrimary`}>
                //         <CPN.Icon type="eye" className="fs20 colorPrimary"/>
                //     </Link>
                // )
            }
            {
                props.permissionActions && props.permissionActions.allowDelete &&
                <CPN.Tooltip title={deleteDisabled ? t(`item.group.cantDeleteGroupStarted`) : undefined}>
                    <Button type="link" icon="delete" className="fs20 colorPrimary p-0" disabled={deleteDisabled} onClick={onRemove} />
                </CPN.Tooltip>
            } */}
            <Dropdown overlay={
                <CPN.Menu className="action-menu">
                    {
                        props.permissionActions && props.permissionActions.allowViewDetail &&
                        <CPN.Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.GROUP.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                                <CPN.Icon 
                                    type={(updateAllowed && props.permissionActions.allowUpdate) ? "form" : "eye"} 
                                    className="fs20" /> 
                                    {(updateAllowed && props.permissionActions.allowUpdate) ? t(`action.edit`) : t(`action.show`)}
                                {/* <CPN.Icon type="eye" className="fs20" /> {t(`action.show`)} */}
                            </Link>
                        </CPN.Menu.Item>
                    }

                    {
                        props.permissionActions && props.permissionActions.allowCreate &&
                        <CPN.Menu.Item onClick={onClone}>
                            <CPN.Icon type="plus-square" className="fs20 mr-1" />{t(`action.clone`)}
                        </CPN.Menu.Item>
                    }

                    {
                        props.permissionActions && props.permissionActions.allowDelete &&
                        <CPN.Menu.Item disabled={deleteDisabled} onClick={onRemove}>
                            <CPN.Tooltip title={deleteDisabled ? t(`item.group.cantDeleteGroupStarted`) : undefined}>
                                <CPN.Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}
                            </CPN.Tooltip>
                        </CPN.Menu.Item>
                    }
                </CPN.Menu>
            }>
                <CPN.Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        </Span>
    )
};
